import api from '../config/api';

const chatService = {
  // Channels
  getChannels: () => api.get('/chat/channels'),
  getChannel: (channelId) => api.get(`/chat/channels/${channelId}`),
  createChannel: (data) => api.post('/chat/channels', data),
  createDirect: (targetUserId) => api.post('/chat/channels/direct', { targetUserId }),
  updateChannel: (channelId, data) => api.put(`/chat/channels/${channelId}`, data),
  archiveChannel: (channelId) => api.post(`/chat/channels/${channelId}/archive`),

  // Members
  getMembers: (channelId) => api.get(`/chat/channels/${channelId}/members`),
  addMembers: (channelId, userIds) => api.post(`/chat/channels/${channelId}/members`, { userIds }),
  removeMember: (channelId, userId) => api.delete(`/chat/channels/${channelId}/members/${userId}`),
  updateMemberRole: (channelId, userId, role) => api.put(`/chat/channels/${channelId}/members/${userId}/role`, { role }),
  toggleMute: (channelId, isMuted) => api.post(`/chat/channels/${channelId}/mute`, { isMuted }),

  // Messages
  getMessages: (channelId, params) => api.get(`/chat/channels/${channelId}/messages`, { params }),
  sendMessage: (channelId, data) => api.post(`/chat/channels/${channelId}/messages`, data),
  uploadFile: (channelId, file, content) => {
    const formData = new FormData();
    formData.append('file', file);
    if (content) formData.append('content', content);
    return api.post(`/chat/channels/${channelId}/messages/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  editMessage: (messageId, content) => api.put(`/chat/messages/${messageId}`, { content }),
  deleteMessage: (messageId) => api.delete(`/chat/messages/${messageId}`),
  markAsRead: (channelId, messageId) => api.post(`/chat/channels/${channelId}/read`, { messageId }),
  searchMessages: (channelId, q) => api.get(`/chat/channels/${channelId}/messages/search`, { params: { q } }),

  // Reactions
  addReaction: (messageId, emoji) => api.post(`/chat/messages/${messageId}/reactions`, { emoji }),
  removeReaction: (messageId, emoji) => api.delete(`/chat/messages/${messageId}/reactions/${encodeURIComponent(emoji)}`),

  // Attachments
  getChannelAttachments: (channelId) => api.get(`/chat/channels/${channelId}/attachments`),
  downloadAttachment: (attachmentId) => api.get(`/chat/attachments/${attachmentId}/download`, { responseType: 'blob' }),
};

export default chatService;
